import { EmptyState } from '../../components/brand/EmptyState.js';

export function SettingsPlaceholderPage(): JSX.Element {
  return (
    <EmptyState
      title="הגדרות"
      description="ניהול מסלולים, עובדים, משתמשים, פרויקטים והעדפות מערכת יוטמעו בתוכנית 03."
      planTag="תוכנית 03"
    />
  );
}
